package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.WebTrafficW500Rounded: ImageVector
    get() {
        if (_webTrafficW500Rounded != null) {
            return _webTrafficW500Rounded!!
        }
        _webTrafficW500Rounded = Builder(name = "WebTrafficW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(118.33f, 398.09f)
                horizontalLineToRelative(39.76f)
                quadToRelative(17.71f, 0.0f, 29.81f, 12.09f)
                quadTo(200.0f, 422.28f, 200.0f, 440.0f)
                reflectiveQuadToRelative(-12.1f, 29.82f)
                quadToRelative(-12.1f, 12.09f, -29.81f, 12.09f)
                horizontalLineToRelative(-39.76f)
                quadToRelative(-17.72f, 0.0f, -29.82f, -12.09f)
                quadToRelative(-12.1f, -12.1f, -12.1f, -29.82f)
                reflectiveQuadToRelative(12.1f, -29.82f)
                quadToRelative(12.1f, -12.09f, 29.82f, -12.09f)
                close()
                moveTo(184.89f, 616.72f)
                lineTo(212.89f, 588.48f)
                quadToRelative(12.48f, -12.48f, 29.32f, -12.1f)
                quadToRelative(16.83f, 0.38f, 29.31f, 12.1f)
                quadToRelative(12.48f, 12.48f, 12.86f, 29.81f)
                quadToRelative(0.38f, 17.34f, -12.1f, 29.82f)
                lineToRelative(-28.0f, 28.0f)
                quadToRelative(-12.48f, 12.48f, -29.81f, 11.98f)
                quadToRelative(-17.34f, -0.5f, -29.82f, -12.98f)
                quadToRelative(-11.72f, -12.48f, -11.98f, -29.2f)
                quadToRelative(-0.26f, -16.71f, 12.22f, -29.19f)
                close()
                moveTo(212.65f, 291.28f)
                lineTo(184.89f, 263.28f)
                quadToRelative(-12.48f, -12.48f, -12.1f, -29.31f)
                quadToRelative(0.38f, -16.84f, 12.1f, -29.32f)
                quadToRelative(12.48f, -12.48f, 29.7f, -12.86f)
                quadToRelative(17.21f, -0.38f, 29.69f, 12.1f)
                lineToRelative(28.24f, 28.0f)
                quadToRelative(12.48f, 12.48f, 11.98f, 29.82f)
                quadToRelative(-0.5f, 17.33f, -12.98f, 29.81f)
                quadToRelative(-12.48f, 11.72f, -29.43f, 11.98f)
                quadToRelative(-16.96f, 0.26f, -29.44f, -12.22f)
                close()
                moveTo(702.28f, 787.54f)
                lineTo(539.57f, 625.07f)
                lineToRelative(-29.05f, 86.89f)
                quadToRelative(-2.48f, 7.95f, -8.69f, 11.93f)
                quadToRelative(-6.22f, 3.98f, -13.18f, 3.98f)
                quadToRelative(-6.95f, 0.0f, -13.05f, -4.48f)
                quadToRelative(-6.1f, -4.48f, -8.34f, -12.43f)
                lineToRelative(-86.48f, -287.92f)
                quadToRelative(-2.48f, -9.43f, 0.26f, -18.39f)
                quadToRelative(2.74f, -8.95f, 8.7f, -14.91f)
                quadToRelative(5.96f, -5.96f, 14.91f, -8.7f)
                quadToRelative(8.96f, -2.74f, 18.39f, -0.26f)
                lineToRelative(289.68f, 86.48f)
                quadToRelative(7.95f, 2.24f, 12.05f, 8.46f)
                quadToRelative(4.1f, 6.21f, 4.1f, 13.17f)
                reflectiveQuadToRelative(-3.48f, 13.06f)
                quadToRelative(-3.48f, 6.09f, -11.43f, 8.57f)
                lineToRelative(-87.37f, 31.05f)
                lineTo(787.3f, 702.28f)
                quadToRelative(13.68f, 13.68f, 13.68f, 32.07f)
                reflectiveQuadToRelative(-13.68f, 32.06f)
                lineToRelative(-21.13f, 21.13f)
                quadToRelative(-13.67f, 13.68f, -31.94f, 13.56f)
                quadToRelative(-18.27f, -0.12f, -31.95f, -13.56f)
                close()
                moveTo(398.09f, 198.09f)
                verticalLineToRelative(-39.76f)
                quadToRelative(0.0f, -17.72f, 12.09f, -29.82f)
                quadToRelative(12.1f, -12.1f, 29.82f, -12.1f)
                reflectiveQuadToRelative(29.82f, 12.1f)
                quadToRelative(12.09f, 12.1f, 12.09f, 29.82f)
                verticalLineToRelative(39.76f)
                quadToRelative(0.0f, 17.71f, -12.09f, 29.81f)
                quadTo(457.72f, 240.0f, 440.0f, 240.0f)
                reflectiveQuadToRelative(-29.82f, -12.1f)
                quadToRelative(-12.09f, -12.1f, -12.09f, -29.81f)
                close()
                moveTo(607.72f, 231.89f)
                lineTo(636.72f, 202.89f)
                quadToRelative(11.71f, -11.72f, 28.93f, -11.98f)
                quadToRelative(17.22f, -0.26f, 29.7f, 12.22f)
                quadToRelative(11.72f, 11.72f, 12.1f, 28.7f)
                quadToRelative(0.38f, 16.97f, -11.34f, 29.45f)
                lineToRelative(-29.0f, 30.0f)
                quadToRelative(-11.72f, 12.48f, -28.94f, 12.22f)
                quadToRelative(-17.21f, -0.26f, -29.69f, -11.98f)
                quadToRelative(-12.48f, -12.48f, -12.86f, -29.81f)
                quadToRelative(-0.38f, -17.34f, 12.1f, -29.82f)
                close()
            }
        }
        .build()
        return _webTrafficW500Rounded!!
    }

private var _webTrafficW500Rounded: ImageVector? = null
